<template>
  <v-row dense class="mt-3">
    <v-col cols="12">
      <h4 class="overline">Transcripts</h4>

      <v-divider class="mb-3" />
    </v-col>

    <v-col cols="12" md="5">
      <v-text-field
        v-model="transcript.description"
        outlined
        dense
        :rules="descriptionRules"
      >
        <template #label>
          <div>
            Transcript Description
            <span class="red--text">*</span>
          </div>
        </template>
      </v-text-field>
    </v-col>

    <v-col cols="12" md="5">
      <v-file-input
        v-model="transcript.attachment"
        outlined
        dense
        accept="application/pdf"
        hint="PDF documents only"
        persistent-hint
        :rules="attachmentRules"
      >
        <template #label>
          <div>
            Transcript Attachment
            <span class="red--text">*</span>
          </div>
        </template>
      </v-file-input>
    </v-col>

    <v-col cols="12" md="2">
      <v-btn color="primary" block height="40" @click="addTranscript">
        <v-icon left> mdi-file-plus </v-icon>

        Add
      </v-btn>
    </v-col>

    <v-col v-if="value.length" cols="12">
      <v-chip
        v-for="(item, index) in value"
        :key="index"
        class="ma-2"
        large
        label
        color="secondary"
        close
        @click="download(item.attachment)"
        @click:close="remove(index)"
      >
        <v-icon left> mdi-file </v-icon>

        {{ item.description }}
      </v-chip>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "TranscriptSection",

  model: {
    prop: "value",
    event: "input",
  },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      transcript: {
        description: "",
        attachment: null,
      },
    };
  },

  computed: {
    descriptionRules() {
      return [(v) => !!v || "Description is required"];
    },

    attachmentRules() {
      return [
        (v) => !!v || "Attachment is required",

        (v) => !v || v.size < 10000000 || "Maximum file size is 10MB",

        (v) =>
          !v ||
          v.type === "application/pdf" ||
          "Only PDF documents are allowed",
      ];
    },
  },

  methods: {
    async addTranscript() {
      if (!this.transcript.description) {
        return;
      }

      if (!this.transcript.attachment) {
        return;
      }

      const attachment = await this.toBase64(this.transcript.attachment);

      this.$emit("input", [
        ...this.value,
        {
          description: this.transcript.description.toUpperCase(),

          attachment,
        },
      ]);

      this.reset();
    },

    remove(index) {
      const data = [...this.value];

      data.splice(index, 1);

      this.$emit("input", data);
    },

    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
          resolve(reader.result.replace("data:", "").replace(/^.+,/, ""));
        };

        reader.onerror = reject;

        reader.readAsDataURL(file);
      });
    },

    download(file) {
      this.$emit("download", file);
    },

    reset() {
      this.transcript = {
        description: "",
        attachment: null,
      };
    },

    validate() {
      return this.value.length > 0;
    },
  },
};
</script>
